// "steps" - is a required translation
export const serviceData = {
  upi_qr: {
    steps: ['invoice_flow__multi_upi_qr_step_1', 'invoice_flow__multi_upi_qr_step_2'],
  },
  pix_qr: {
    steps: ['invoice_flow__multi_upi_qr_step_1', 'invoice_flow__multi_upi_qr_step_2'],
  },
  bank_transfer: {
    steps: ['invoice_flow__multi_bank_transfer_step_1', 'invoice_flow__multi_bank_transfer_step_2'],
  },
  card_transfer: {
    steps: ['invoice_flow__card_transfer_step_1', 'invoice_flow__card_transfer_step_2'],
  },
  card_transfer_humo: {
    steps: ['invoice_flow__card_transfer_step_1', 'invoice_flow__card_transfer_step_2'],
  },
  card_transfer_uzcard: {
    steps: ['invoice_flow__card_transfer_step_1', 'invoice_flow__card_transfer_step_2'],
  },
  rapipago: {
    steps: ['invoice_flow__multi_rapipago_step_1', 'invoice_flow__multi_rapipago_step_2'],
  },
};
